module.exports = require("webpack-sources");